import { useJsApiLoader } from '@react-google-maps/api';

import { PageLoading } from '@/app/ui/page';

const libraries = ['places'];

const GoogleMapsLoader = ({ children }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    libraries,
    googleMapsApiKey: 'AIzaSyBYJHu7sKU5Hc4Aw0nFYk9R4bUBS0Zzhg4'
  });

  if (!isLoaded) {
    return <PageLoading variant="app" />;
  }

  return children;
};

export default GoogleMapsLoader;
